export enum SAAS_PAYMENT_STATUS {
  // debit payment status
  PAID = 'P',
  HALF_PAID = 'HP',
  DUE = 'D',
  OVER_DUE = 'OD',

  // credit payment status
  OPEN = 'O',
  OPEN_PARTIAL = 'OP',
  UTILIZED = 'U',
}

export enum SAAS_PAYMENT_MODE {
  BANK = 'BT',
  CARD = 'CD',
  CASH = 'CS',
}

export enum SAAS_PAYMENT_TYPE {
  CREDIT = 'C',
  DEBIT = 'D',
}

export enum SAAS_PAYMENT_CHIP_COLORS {
  PAID = '#459B64',
  DUE = '#B43236',
  OPEN_PARTIAL = '#E6A02A', // should change
  OPEN = '#E6A03A',
  UTILIZED = '#3474E0', // should change

  TEXT_COLOR = 'white',
}
